/**
 * @fileoverview This file contains the layout component for the application, including a sidebar and header.
 * @author Sravani
 */
import React, { useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import { Avatar, Button, Layout, Menu, Select } from "antd"
import Cookies from "js-cookie";
import { Modal } from "antd"
import "./sideBar.css"
import { useMsal } from "@azure/msal-react"
import { useDispatch, useSelector } from "react-redux"
import * as Icons from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import {
  setInterventionActiveTabKey,
  setInterventionDetailsActiveTabKey,
} from "../../../redux/reducer/interventionSlice"
import { openPopup } from "../../../redux/reducer/aiInterventionPopUpSlice"

import {
  PoweroffOutlined,
  HomeFilled,
  RightOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  PushpinOutlined, 
  PushpinFilled
} from "@ant-design/icons"
import {
  setReduxCurrency,
  setReduxUnit,
} from "../../../redux/reducer/currencySlice"
import { usePowerBI } from "components/waste_overview/powerBI/powerbiContext"
import { persistor } from "../../../redux/config/store"
import { initializeMSAL, trigerAccountCreation } from "sso/msalInstance"
import { getHeaders } from "services/utilService"
import Logo from "../../../assets/Logo-white-transparent-RGB 2.png"
import homeIcon from "../../../assets/homeIcon.svg"
import countryBenchmark from "../../../assets/countryBenchmark.svg"
import wasteOverview from "../../../assets/wasteOverview.svg"
import intervationCenter from "../../../assets/intervationCenter.svg"
import settingsIcon from "../../../assets/settingsIcon.svg"
import countrySelectIcon from "../../../assets/country.svg"
import designToDistributeIcon from "../../../assets/dispatch.svg"
import directDispatchIcon from "../../../assets/behaviour.svg"
import palletHeightIcon from "../../../assets/country.svg"
import { closePopup } from "../../../redux/reducer/aiInterventionPopUpSlice"
import LogoImg from "../../../assets/logo-new.png"
import {DISABLED_MENU_ITEMS} from '../../../constants/app-constants'

const { Header, Sider } = Layout
const { Content } = Layout

const unitOptions = [
  { value: "Millimeter", label: "Millimeter, Kgs" },
  { value: "inch", label: "Inches, Pounds" },
]
/**
 * @class MyLayout
 * @description This component renders the main layout with a sidebar, header, and content area.
 */
const MyLayout = props => {
  const { Option } = Select
  const { instance, accounts } = useMsal()
  const [selectedIcon, setSelectedIcon] = useState(null)
  const [isActive, setActive] = useState(false)
  const [activeItem, setActiveItem] = useState("")
  const [imageUrl, SetImageUrl] = useState(null)
  const fullName = accounts[0]?.name || "User"
  const firstName = fullName.split(" ")[1]
  const lastName = fullName.split(" ")[0]
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [isHovered, setIsHovered] = useState(false)
  const [powerBILink, setPowerBILink] = useState([])
  const [isExpanded, setIsExpanded] = useState(false)
  const { setPowerBILinkItem } = usePowerBI() // Access the setter function from context
  const dispatch = useDispatch()
  const currency = useSelector(state => state.currencySlice.currency)
  const unit = useSelector(state => state.currencySlice.unitOfMeasure)
  const state = useSelector(state => state.InterventionDetails.filterListData)
  const [selectedCurrency, setSelectedCurrency] = useState(currency?.value)
  const [selectedUnit, setSelectedUnit] = useState(unit?.value)
  const navigate = useNavigate()
  const [isPinned, setIsPinned] = useState(false);

  const storedCountry = useSelector(
    (state) => state?.InterventionDetails?.globalCountrySelected
  );
  
  const densitypayload = {
    country : storedCountry,
    businessGroup: "",
    Category: "",
    format: [],
    PackType: [],
    PackSize: [],
    TargetDensity: "Top Performers (Country)",
    riskFactor2Y: 25,
    riskSavingfactor: 25,
    primaryRisk: 75,
    palletRisk: 25,
    maxPalletWeight_single: 2205,
    maxPalletWeight_double: 2205,
  }
  const heightpayload = {
    country : storedCountry,
    businessGroup: "",
    category: "",
    brand: "",
    format: "",
    sizePackForm: "",
    specialPack: "",
  }

  const data = {
    Intervention_ID: "",
    kpi: "1Y TLU Design, 2Y TLU Design, WH Waste",
    popupType: "",
  }

  const currencyMap = {
    US: { value: "Dollar", label: "Dollar $" },
    BR: { value: "R$", label: "BR R$" },
    MX: { value: "MX$", label: "MX$" },
    ID: { value: "DRp", label: "ID Rp" },
  }

  const countryCurrency =
    currencyMap[state.country ? state?.country : "US"] || null

  const currencyOptions = [
    ...(countryCurrency ? [countryCurrency] : []),
    { value: "Euro", label: "Euro €" },
  ]

  /**
   * Initializes MSAL instance, triggers account creation, and fetches Power BI links on component mount.
   * Resets the expanded state when the component unmounts.
   */

  useEffect(() => {
    const initializeMSALInstance = async () => {
      await initializeMSAL()
      trigerAccountCreation()
    }

    initializeMSALInstance()
    fetchPowerBILinks()
    setIsExpanded(false)
    return () => {
      setIsExpanded(false)
    }
  }, [])

  useEffect(() => {
    if (isPinned) {
      setIsExpanded(true);
    }
  }, [isPinned]);
  
  useEffect(() => {
    if (storedCountry) {
      fetchPowerBILinks();
    }
  }, [storedCountry]);

  useEffect(() => {
    state.country == "BR"
      ? setSelectedCurrency("BR R$")
      : state.country == "MX"
        ? setSelectedCurrency("MX$")
        : state.country == "ID"
          ? setSelectedCurrency("ID Rp")
          : setSelectedCurrency("Dollar")
  }, [state.country])
  /**
   * @function fetchPowerBILinks
   * @description Fetches Power BI links from an API and updates the state with the formatted data.
   * @returns {void} Updates the state with the fetched Power BI links.
   */
  const getIconByName = iconName => {
    switch (iconName) {
      case "homeIcon":
        return homeIcon
      case "countrySelectIcon":
        return countrySelectIcon
      case "TLUSimulatortIcon":
        return countryBenchmark
      case "profitabilityServiceIcon":
        return countryBenchmark
      case "outboundHandlingIcon":
        return wasteOverview
      case "customerBehaviourIcon":
        return designToDistributeIcon
      case "designToDistributeIcon":
        return intervationCenter
      case "palletHeightIcon":
        return palletHeightIcon
      case "directDispatchIcon":
        return directDispatchIcon
      case "countryBenchmark":
        return countryBenchmark
      case "countryBenchmark_US":
        return countryBenchmark
      case "countryBenchmark_MX_BR":
        return countryBenchmark
      case "countryBenchmark LATAM":
        return countryBenchmark
      case "wasteInsightsIcon":
          return wasteOverview
      case "wasteOverview_US":
        return wasteOverview
      case "wasteOverview_MX_BR":
        return wasteOverview
      case "wasteOverview_LATAM":
        return wasteOverview
      case "intervationCenter":
        return intervationCenter
      case "settingsIcon":
        return settingsIcon
      default:
        return null // or a fallback icon if you want
    }
  }

  const fetchPowerBILinks = async () => {
    try {

      const mapDataRecursively = (item) => ({
        key: item.ID,
        title: item.Title == 'Country Selection' && storedCountry ? `Country Selection (${storedCountry})` : item.Title,
        icon: getIconByName(item.Icon),
        name: item.Name,
        path: item.Path,
        reportType: item.ReportType,
        ID: item.ID,
        isExternal : item.IsExternal,
        url : item.Url,
        child: item.child ? item.child.map(mapDataRecursively) : undefined,
      });
  
      // // Perform the API call with the Authorization header
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/reports/getReportsV2?country=${storedCountry}`,
        {
          method: "GET", 
          headers: await getHeaders(),
        },
      )

      if (!response.ok) {
        localStorage.clear()
      }

      const data = await response.json()

      const updatedPowerBILinks = data.data.map(mapDataRecursively);


      setPowerBILink(updatedPowerBILinks)
    } catch (error) {
    if(error.message == "Unauthorized - Invalid token"){
        localStorage.clear()
      }
      console.error("Error fetching Power BI links:", error)
    }
  }




  /**
   * @function showModal
   * @description Shows the modal by setting its visibility to true.
   * @returns {void} Sets the modal visibility state to true.
   */
  const showModal = () => {
    setIsModalVisible(true)
  }
  /**
   * @function handleCancel
   * @description Closes the modal by setting its visibility to false.
   * @returns {void} Sets the modal visibility state to false.
   */
  const handleCancel = () => {
    setIsModalVisible(false)
    setSelectedCurrency(currency?.value)
    setSelectedUnit(unit?.value)
  }

  // Fetch the Power BI links dynamically from an API

  /**
   * @function getInitials
   * @description Extracts the initials from a full name.
   * @param {string} name - The full name of the user.
   * @returns {string} The initials of the user.
   */
  const getInitials = name => {
    const nameParts = name.split(" ")
    const firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || ""
    const lastNameInitial =
      nameParts.length > 1
        ? nameParts[1]?.charAt(0).toUpperCase()
        : firstNameInitial
    return `${firstNameInitial}${lastNameInitial}`
  }
  const initials = getInitials(fullName)

  /**
   * @function handleCurrencyChange
   * @description Handles the change of currency selection.
   * @param {string} name - The name of the currency.
   * @param {string} value - The selected currency value.
   */
  const handleCurrencyChange = (name, value) => {
    setActive(false)
    // setCurrency(value)
    dispatch(setReduxCurrency(value))
  }
  const [dropdownStates, setDropdownStates] = useState({
    currency: false,
    unit: false,
  })
  /**
   * @function handleChange
   * @description Handles the selection change in the dropdown.
   * @param {any} value - The selected dropdown value.
   */
  const handleChange = value => {
    onChange && onChange(name, value)
    setDropdownOpen(false)
  }
  /**
   * @function handleDropdownVisibleChange
   * @description Controls the visibility of the dropdown.
   * @param {boolean} open - The state indicating if the dropdown is open.
   */
  const handleDropdownVisibleChange = (type, open) => {
    setDropdownStates(prevState => ({
      ...prevState,
      [type]: open,
    }))
  }
  /**
   * Sets the page title and subtitle based on the current route.
   * @constant {string} title - The main title of the page.
   * @constant {string} subtitle - The subtitle of the page based on route.
   */
  const location = useLocation()

  let title = "Cost to Serve - Deep Dive Tool"
  let subtitle = ""

  switch (location.pathname) {
    case "/service":
      subtitle = "landing"
      break
    case "/country":
      subtitle = "Country KPI View"
      break
    case "/intervention_centre":
      title = "Intervention Center"
      subtitle = "Intervention Center"
      break
    // case "/registered_Intervention":
    //   subtitle = "Registered Intervention Center"
    //   break
    // case "/ai_suggestions":
    //   subtitle = "AI-Suggested Intervention Center"
    //   break
    case "pb/waste_overview":
      subtitle = "WASTE Overview"
      break
    case "pb/Country_Benchmarking":
      subtitle = "Country Benchmarking"
      break
    case "/waste_deepdive":
      subtitle = "WASTE Deep Dive"
      break
    default:
      const foundLink = powerBILink?.find(pb => pb.path === location.pathname)
      if (foundLink) {
        subtitle = foundLink.title
      } else {
        subtitle = "Overview"
      }
      break
  }
  /**
   * @function handleIconClick
   * @description Handles the icon selection event.
   * @param {any} icon - The selected icon.
   */
  const handleIconClick = icon => {
    setSelectedIcon(icon)
  }

  /**
   * @function handleLogout
   * @description Logs the user out of the application.
   * @param {string} logoutType - The type of logout to perform (popup or redirect).
   */
  const handleLogout = logoutType => {
    dispatch(setReduxCurrency({ value: "Dollar", label: "Dollar" }))
    dispatch(setReduxUnit({ value: "inch", label: "inch" }))
    dispatch(closePopup())
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: `${process.env.REACT_APP_SSO_REDIRECT_URI}`,
        mainWindowRedirectUri: "",
      })
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: `${process.env.REACT_APP_SSO_REDIRECT_URI}`,
      })
    }
    persistor.purge()
    dispatch({
      type: "RESET_TO_INITIAL",
      payload: "",
    })
    localStorage.removeItem("authUser")

    // Remove from localStorage
    localStorage.removeItem(`CTS - 2.0 ${process.env.REACT_APP_ENV}`)

    // Remove the cookie
    Cookies.remove("COOKIE_ACCEPTED")
  }

  /**
   * @function isActiveTab
   * @description Checks if the current path is active.
   * @param {string} path - The path to check against.
   * @returns {boolean} True if the path is active, false otherwise.
   */
  const isActiveTab = path => {
    return location.pathname.startsWith(path)
  }
  /**
   * @function handleSave
   * @description Saves the selected currency and unit to the Redux store and closes the modal.
   * @returns {void} Dispatches actions to save the selected currency and unit, and closes the modal.
   */
  const handleSave = () => {
    dispatch(
      setReduxCurrency({
        key: selectedCurrency,
        value: selectedCurrency,
        children: selectedCurrency,
      }),
    )
    dispatch(setReduxUnit({ value: selectedUnit, label: selectedUnit }))
    setIsModalVisible(false)
  }

  return (
    <Layout className="layout-container">
      {/* {location.pathname !== "/service" && ( */}
      <Sider
          width={70}
          theme="light"
          style={{
            zIndex: isExpanded ? 1000 : 0, // Dynamically set zIndex
            transition: "width 0.2s ease-in-out, z-index 0.2s ease-in-out",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)", // Center the logo horizontally
              zIndex: 10, // Keep the logo on top of other content
            }}
          >
            <img
              src={Logo}
              alt="unileverlogo"
              loading="lazy"
              className={`sider-logo ${isExpanded ? "expanded" : ""}`}
            />
          </div>

        <div
          className={`sidebar ${isExpanded ? "expanded" : ""}`}
          onMouseEnter={() => {
            if (!isPinned) setIsExpanded(true);
          }}
          onMouseLeave={() => {
            if (!isPinned) setIsExpanded(false);
          }}
          style={{
            paddingTop: "68px",
          }}
        >
          <div style={{
            position: "absolute",
            top: "25px",
            left: "270px",
            color: "#fff",
          }}>
            {isExpanded && <span onClick={() => { setIsPinned((prev) => !prev);}}>
              {isPinned ? <PushpinFilled style={{ cursor: "pointer",fontSize: "20px" }} /> : <PushpinOutlined style={{ cursor: "pointer",fontSize: "20px" }} />}
            </span>
            }
          </div>
            <Menu
              className="menu-bar"
              mode="vertical"
              defaultSelectedKeys={["1"]}
              selectedKeys={[location.pathname]}
              triggerSubMenuAction="hover"
              subMenuOpenDelay={0.1}
              subMenuCloseDelay={0.2}
            >
              <>
                {powerBILink.map(pb => {
                  // Recursive function to render menu items with children
                  const renderMenuItem = (item, parentKey = "") => {
                    const itemKey = parentKey ? `${parentKey}-${item.ID}` : `${item.ID}`;
                    const hasChildren = item.child && item.child.length > 0;

                    if (hasChildren) {
                      // Render as SubMenu if item has children
                      return (
                        <Menu.SubMenu
                          key={itemKey}
                          className={`tabs ${isActiveTab(item.path) ? "active-tab" : ""}`}
                          icon={
                            !parentKey ? (
                              <img
                                src={item.icon}
                                alt={item.icon}
                                loading="lazy"
                                style={{
                                  paddingLeft: "10px",
                                  width: "30px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                            ) : undefined
                          }
                          title={isExpanded ? item.title : ""}
                        >
                          {item.child.map(childItem => renderMenuItem(childItem, itemKey))}
                        </Menu.SubMenu>
                      );
                    } else {
                      // Render as regular Menu.Item if no children
                      return (
                        <Menu.Item
                          key={itemKey}
                          disabled={DISABLED_MENU_ITEMS.includes(item.title)}
                          className={`tabs ${isActiveTab(item.path) ? "active-tab" : ""} 
                          ${ DISABLED_MENU_ITEMS.includes(item.title) ? "disabled-tab" : ""}`}
                          onClick={() => {
                            if (item.title == "Setting") {
                              showModal()
                            }else if(item.isExternal){
                              if (item.url) {
                                window.open(item.url, "_blank", "noopener,noreferrer")
                              }
                            }else if (item.title === "Pallet Height & Weight") {
                              dispatch({
                                type: "SELECTED_FILTERHEIGHT",
                                payload: heightpayload,
                              })
                              dispatch({
                                type: "SELECTED_FILTERAI",
                                payload: {
                                  country : storedCountry,
                                  wasteLevel1: "All",
                                  wasteLevel2: "All",
                                  area: "All",
                                  businessGroup: "",
                                  interventionBucket: "Design to Distribute",
                                  simulation: "Yes - D2D Height",
                                },
                              })
                              navigate("/intervention_centre")
                              dispatch(setInterventionActiveTabKey("ai"))
                              dispatch(openPopup({ ...data, Intervention_ID: "21" }))
                            }else if (item.title === "Ideal Density") {
                              dispatch({
                                type: "SELECTED_FILTERDENSITY",
                                payload: densitypayload,
                              })
                              dispatch({
                                type: "SELECTED_FILTERAI",
                                payload: {
                                  country : storedCountry,
                                  wasteLevel1: "All",
                                  wasteLevel2: "All",
                                  area: "All",
                                  businessGroup: "",
                                  interventionBucket: "Design to Distribute",
                                  simulation: "Yes - D2D Density",
                                },
                              })
                              navigate("/intervention_centre")
                              dispatch(setInterventionActiveTabKey("ai"))
                              dispatch(setInterventionDetailsActiveTabKey("simulation"))
                              dispatch(openPopup({ ...data, Intervention_ID: "22" }))
                            }else{
                              setSelectedIcon(item.name)
                              dispatch({
                                type: "SELECTED_POWERBI",
                                payload: item,
                              })
                              setPowerBILinkItem(item)
                            }

                          }}
                        >
                          {
                            !item.isExternal
                          }
                          <Link to={item.isExternal ? "#" : item.path} onClick={(e) => {
                              if (item.isExternal) {
                                e.preventDefault();
                              }
                            }}>
                            {!parentKey && (
                              <img
                                src={item.icon}
                                alt={item.icon}
                                loading="lazy"
                                style={{
                                  paddingLeft: "10px",
                                  width: "30px",
                                  height: "20px",
                                  cursor: "pointer",
                                }}
                              />
                            )}
                            {isExpanded && <p>{item.title}</p>}
                          </Link>
                        </Menu.Item>
                      );
                    }
                  };

                  return renderMenuItem(pb);
                })}
              </>
            </Menu>
          </div>
        </Sider>
      {/* )} */}

      <Layout>
        {!location.pathname.startsWith("/pb/") &&
          location.pathname !== '/country-selection' &&
          location.pathname !== "/service" &&
          location.pathname !== "/Country_Benchmarking" &&
          location.pathname !== "/Waste_Deep_Dive" && (
            <div className="header-container" 
            style={{
               paddingLeft: !isExpanded ? "" : "240px"
             }}
           >
              <div className="profile-header">
                <div className="left-side">
                  <div className="title">{title}</div>
                  <div className="title-sub-title">
                    <HomeFilled /> Cost To Serve <RightOutlined /> {subtitle}
                  </div>
                </div>
                <div className="right-side">
                  {/* {!isActive && (
                <p
                  style={{
                    color: "#292929",
                    marginTop: "22px",
                    fontSize: "14px",
                    fontFamily: "Unilever Shilling",
                  }}
                  onClick={handleClick}
                >
                  Select Currency Type($)
                </p> */}
                  {/* )} */}
                  {/* {isActive && ( */}
                  {location.pathname !== "/ai_suggestions/options" && (
                    <div className="filter-section">
                      {/* <Select
                        className="filter-dropdown"
                        placeholder="Select here"
                        onChange={handleCurrencyChange}
                        value={currency}
                        suffixIcon={
                          dropdownOpen ? (
                            <img
                              src={uparrow}
                              alt="up Arrow"
                              style={{ width: "20px", height: "20px" }}
                            />
                          ) : (
                            <img
                              src={downarrow}
                              alt="down arrow"
                              style={{ width: "20px", height: "20px" }}
                            />
                          )
                        }
                      >
                        {currencyOptions.map(option => (
                          <Option key={option.value} value={option.value}>
                            {option.label}
                          </Option>
                        ))}
                      </Select> */}
                    </div>
                  )}
                  {/* )} */}
                  <div>
                    <img
                      src={LogoImg}
                      alt="unileverlogo"
                      loading="lazy"
                      className="CTS-logo"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        {location.pathname === "/service" && (
          <div className="header-container" style={{ paddingLeft: !isExpanded ? "" : "240px" }}>
            <div className="profile-header">
              <div className="left-side">
                <div className="title">Hello {firstName},</div>
                <div className="title-sub-title">
                  Welcome to Cost-to-Serve AI and Simulation Homepage
                </div>
              </div>
              <div className="right-side">
                <div>
                  <img
                    src={LogoImg}
                    alt="unileverlogo"
                    loading="lazy"
                    className="CTS-logo"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <Content
          className="before-login-main-content"
          style={{ paddingLeft: !isExpanded ? "" : "240px" }}
        >
          {props.children}
        </Content>
      </Layout>

      <Modal
        title="Settings"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={600}
        className="settings-modal"
      >
        <div className="modal-content">
          <div className="dropdowns-container">
            <div className="dropdown-section">
              <label>Currency</label>
              <Select
                value={selectedCurrency}
                onChange={value => setSelectedCurrency(value)}
                style={{ width: "100%" }}
                suffixIcon={
                  dropdownStates.unit ? (
                    <CaretUpOutlined
                      style={{ color: "black", fontSize: "14px" }}
                    />
                  ) : (
                    <CaretDownOutlined
                      style={{ color: "black", fontSize: "14px" }}
                    />
                  )
                }
                onDropdownVisibleChange={open =>
                  handleDropdownVisibleChange("unit", open)
                }
              >
                {currencyOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>

            {/* Unit of Measure Dropdown */}
            <div className="dropdown-section">
              <label>Unit of Measure</label>
              <Select
                value={selectedUnit}
                onChange={value => setSelectedUnit(value)}
                style={{ width: "100%" }}
                suffixIcon={
                  dropdownStates.currency ? (
                    <CaretUpOutlined
                      style={{ color: "black", fontSize: "14px" }}
                    />
                  ) : (
                    <CaretDownOutlined
                      style={{ color: "black", fontSize: "14px" }}
                    />
                  )
                }
                onDropdownVisibleChange={open =>
                  handleDropdownVisibleChange("currency", open)
                }
              >
                {unitOptions.map(option => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="profile">
            <div>
              <Avatar size="default" className="profile-picture">
                {initials}
              </Avatar>
            </div>
            <div className="profile-name">{firstName}</div>
            <PoweroffOutlined
              style={{
                fontSize: "20px",
                cursor: "pointer",
                color: "#292929",
              }}
              onClick={() => handleLogout("popup")}
            />
          </div>

          <div className="modal-buttons" style={{ textAlign: "right" }}>
            <Button onClick={handleCancel} style={{ marginRight: "10px" }}>
              Cancel
            </Button>
            <Button type="primary" onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  )
}

export default MyLayout
